import { render, staticRenderFns } from "./emailInvalid.vue?vue&type=template&id=6e380d6e&"
import script from "./emailInvalid.vue?vue&type=script&lang=js&"
export * from "./emailInvalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports